export default "__VITE_ASSET__8fd5a030__"